import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { PostProductsDrawer } from '../../ui/posts/PostProductsDrawer';
import { analyticsService } from '../../utils/analyticsService';
import { trackEcommerceEvent } from '../../utils/ecommerce';
import {
    getPageNameByEventSource,
    ymTrackMoreProductsClickOut,
    ymTrackProductClickOut,
} from '../../utils/metrika';
import { useBackButton } from '../../utils/useBackButton';
import { DEFAULT_CLOSE_ANIMATION_DELAY } from '../constants';
import { useCurrentUser } from '../users/useCurrentUser';

export const PostProductsDialog = () => {
    const { state } = useLocation();
    const { post, eventSource } = state;
    const { products, business } = post;
    const onNavigateBack = useBackButton();
    const currentUser = useCurrentUser();

    const closeDialog = useCallback(() => {
        setTimeout(onNavigateBack, DEFAULT_CLOSE_ANIMATION_DELAY);
    }, [onNavigateBack]);

    const trackProductClickOut = useCallback(
        (props: { url?: string; target: string; productId?: string }) => {
            analyticsService.trackClickOut({
                postId: post.id,
                djRequestId: post.djRequestId,
                clickoutUrl: props.url,
                eventSource,
                productId: props.productId,
                target: props.target,
            });
            props.target === 'product'
                ? ymTrackProductClickOut({
                      page: getPageNameByEventSource(eventSource),
                      userLogin: currentUser?.login,
                  })
                : ymTrackMoreProductsClickOut({
                      page: getPageNameByEventSource(eventSource),
                      userLogin: currentUser?.login,
                  });
            trackEcommerceEvent({
                post,
                trackEcommerceView: true,
                trackEcommerceAdd: true,
            });
        },
        [products, business, currentUser?.login, eventSource],
    );

    return (
        <PostProductsDrawer
            trackProductClickOut={trackProductClickOut}
            products={products}
            business={business}
            handleClose={closeDialog}
        />
    );
};
